<template>
  <scroll-view :scroll="true" class="search-flex" v-on:bindscrolltolower="scroll_y()">
    <div class="more-goods-body">
      <goods-view v-for="(item,index) in list" :key="index" :item="item" :goodsobject="{list:list,index:index}"></goods-view>
      <loadMore :loadingType="loadingType" style="width: 100%;"></loadMore>
    </div>
  </scroll-view>
</template>

<script>
  import {
    AlbumPicgetlist
  } from '@/request/api.js';
  import {
    Tab,
    Tabs
  } from 'vant';
  export default {
    components: {
      [Tab.name]: Tab,
      [Tabs.name]: Tabs
    },
    data() {
      return {
        keyword: '',
        list: [],
        current_page: 1,
        last_page: 10,
        loadingType: 2
      }
    },
    created() {
      let param = this.$api.parseUrl();
      document.title = param.keyword + '搜索结果';
      this.keyword = param.keyword;
      this.scroll_y();
      typeof WeixinJSBridge != 'undefined' && WeixinJSBridge.call('hideOptionMenu');
    },
    methods: {
      async AlbumPicgetlist_load() {
        let param = {
          directory_id: 0,
          page: this.current_page,
          keyword: this.keyword,
		  albumAlias: this.$store.state.loginInfo.album_alias
        }
        if (this.loadingType != 1) {
          this.loadingType = 1;
          let res = await AlbumPicgetlist(param);
          this.list = this.current_page == 1 ? res.data.data : this.list.concat(res.data.data);
          this.current_page = parseInt(res.data.current_page) + 1;
          this.last_page = res.data.last_page;
          this.loadingType = this.current_page <= this.last_page ? 0 : 2;
        }
      },
      scroll_y() {
        if (this.current_page <= this.last_page) {
          this.AlbumPicgetlist_load()
        }
      }
    }
  }
</script>

<style lang="less">
  .search-flex {
    .more-goods-body {
      width: 96%;
      padding: 2%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .more-van-tabs {
      width: 100%;
      position: sticky;
      top: 0;
      border-bottom: 1px solid #F4F4F4;
    }
  }
</style>
